import { SyntheticEvent, useEffect, useState } from "react";
import { useContextSite } from "../../../context/Context";
import { toast } from "react-toastify";
import { Agendamento } from "../../../services/Agendamento";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  IAgendamentoDTO,
  IReembolsoConfirmarForm,
} from "../../../types/agendamento";
import { StatusAgendamentoEnum } from "../../../enums/statusAgendamento";
import dayjs from "dayjs";

export interface IModalReembolsoProps {
  isOPen: boolean;
  date?: Date;
}

export const useScheduleDetail = () => {
  const [step, setStep] = useState(1);
  const { setIsLoad } = useContextSite();
  const [searchParams, setSearchParams] = useSearchParams();
  let uuidAgendamento = searchParams.get("id");
  const [modalReembolso, setModalReembolso] = useState<IModalReembolsoProps>({
    isOPen: false,
  });
  const [agendamento, setAgendamento] = useState<IAgendamentoDTO>(
    {} as IAgendamentoDTO
  );
  const navigate = useNavigate();

  function cancelarAgendamento() {
    setIsLoad(true);
    Agendamento.cancelar({ uuid: agendamento?.uuid })
      .then(({data}) => {
        if (data?.encaminharFormulario) {
          setTimeout(() => {
            navigate(
              `/agendamento/${agendamento?.uuid}/pagamento/formulario-reembolso`
            );
          }, 1500);
        }
        if (data?.confirmarReembosloPix) {
          navigate(`/agendamento/pagamento/cancelamento-pix`);
        }
        toast.success("Agendamento cancelado com sucesso");
        setTimeout(() => {
          navigate(
            `/meus-agendamentos/agendamento?id=${agendamento?.uuid}`
          );
        }, 1500);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function confirmarReembolso(e: SyntheticEvent) {
    e.preventDefault();
    setIsLoad(true);
    const PAYLOAD: IReembolsoConfirmarForm = {
      uuid: uuidAgendamento,
      dataDevolucao: dayjs(modalReembolso?.date).toISOString(),
    };

    Agendamento.confirmarReembolso(PAYLOAD)
      .then(({ data }) => {
        setAgendamento(data);
        toast.success("Reembolso confirmado");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
        setModalReembolso({ isOPen: false, date: null });
      });
  }

  useEffect(() => {
    if (uuidAgendamento) {
      setIsLoad(true);
      Agendamento.getById({ uuid: uuidAgendamento })
        .then(({ data }) => setAgendamento(data))
        .catch(
          ({
            response: {
              data: { mensagem },
            },
          }) => toast.error(mensagem)
        )
        .finally(() => setIsLoad(false));
    }
  }, [uuidAgendamento]);

  const menuDisabled = [
    StatusAgendamentoEnum.CANCELADO,
    StatusAgendamentoEnum.INICIADO,
    StatusAgendamentoEnum.FINALIZADO,
  ].includes(agendamento?.status);

  // Função depreciada devido à implementação das múltiplas faturas
  // function acessarFatura() {
  //   agendamento?.fatura?.pix?.qrcodeText !== null
  //     ? navigate(`/agendamento/${uuidAgendamento}/fatura`)
  //     : window.open(`${agendamento?.fatura?.url}.pdf`, "_blank");
  // }

  function confirmarPagamento() {
    setIsLoad(true);
    Agendamento.confirmarPagamento({ uuid: uuidAgendamento })
      .then(({ data }) => setAgendamento(data))
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  function retornarStatusIniciado() {
    setIsLoad(true);
    Agendamento.retornarStatusIniciado({ uuid: uuidAgendamento })
      .then(({ data }) => setAgendamento(data))
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  return {
    step,
    setStep,
  };
};
